import fullHeight from './full-height';

const css = () => `${fullHeight}`;

export default {
  css,
};
